// 日付をリクエストパラメータ用に変換する関数
// JavaScriptのDateはJSONにした際にタイムゾーンがUTCに変換されるため、日時のズレを直すため下記の処理が必要になる
export const convertDateToRequestParam = (date: Date) => {
  const offset = date.getTimezoneOffset()
  return new Date(date.getTime() - offset * 60 * 1000)
}
